"use client";
import { FC } from "react";
import { cn } from "utils";
import { Modal, ModalProps } from "../Modal";
import Link from "next/link";

interface CreatHandleProps extends ModalProps {
  hash: string;
}

const hashHost = {
  dev: "https://testnet.bscscan.com/tx",
  beta: "https://testnet.bscscan.com/tx",
  pre: "https://bscscan.com/tx",
  prod: "https://bscscan.com/tx"
}[process.env.NEXT_PUBLIC_ENV || 'dev']

export const SuccessModal: FC<CreatHandleProps> = (props) => {
  const { close, hash } = props;
  return (
    <Modal
      {...props}
      modalContainerClassName="overflow-visible w-[408px] h-[576px] bg-Backgroun-Primary px-6 pt-16 pm-6"
      closeAble={true}
    >
      <div className="text-center font-luckiestGuy text-4.33xl text-Accent-Accent1 mb-4">Successfully claimed</div>
      <img
        src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/successTip.webp`}
        alt='successTip'
        className={cn('w-full h-[240px]')}
      />
      <Link href={`${hashHost}/${hash}`} target="_blank" className="btn-lg btn-fill-green rounded-[20px] mt-4 mb-2">View transaction</Link>
      <button className="btn-lg mt-4 text-Content-Tertiary" onClick={close}>Cancel</button>
    </Modal>
  );
};
